export class PaginationInput {
  page: number;
  itemPerPage: number;

  constructor(page: number, itemPerPage: number) {
    this.page = page;
    this.itemPerPage = itemPerPage;
  }
}
